<section class="ut-dash-card checklist" aria-labelledby="dashboardChecklistTitle">
  <div class="checklist__header">
    <div class="checklist__heading">
      <span class="ut-dash-icon checklist__heading-icon" aria-hidden="true">
        <i class="material-icons">star</i>
      </span>
      <h2 class="checklist__title" id="dashboardChecklistTitle">New Joiner Checklist</h2>
    </div>
    <p class="checklist__intro">
      Complete the following tasks to maximize your chance of getting selected for projects and to start off strong in the uTest community.
    </p>
  </div>

  <ul class="checklist__items">
    @for (task of tasks; track task.label) {
      <li class="checklist__item" [class.checklist__item--done]="task.done">
        <i class="material-icons checklist__icon" [class.checklist__icon--todo]="!task.done" aria-hidden="true">
          {{ task.done ? 'check_circle' : 'panorama_fish_eye' }}
        </i>
        <div class="checklist__text">
          @if ((task.done && task.staticWhenDone) || (!task.href && !task.state)) {
            <span class="checklist__label">{{ task.label }}</span>
          } @else if (task.state) {
            <a class="checklist__label" [uiSref]="task.state" [uiParams]="task.params">{{ task.label }}</a>
          } @else {
            <a class="checklist__label" [href]="task.href">{{ task.label }}</a>
          }
          <!-- The strike-through only shows completion visually, so it is also said in text. -->
          <span class="sr-only">{{ task.done ? ', completed' : ', not completed' }}</span>
          @if (!task.done && task.description) {
            <p class="checklist__description">{{ task.description }}</p>
          }
        </div>
      </li>
    }
  </ul>
</section>
